import { WatchlistUiState, INITIAL_WATCHLIST_UI_STATE } from './watchlist-ui-state';
import { WatchlistStoreData, WATCHLIST_INITIAL_STORE_DATA } from './watchlist-store-data';

export interface WatchlistApplicationState {
    watchlistUiState: WatchlistUiState;
    watchlistStoreData: WatchlistStoreData;
}

export const INITIAL_WATCHLIST_APPLICATION_STATE: WatchlistApplicationState = {
    watchlistUiState  : INITIAL_WATCHLIST_UI_STATE,
    watchlistStoreData: WATCHLIST_INITIAL_STORE_DATA
};



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/watchlist-state.ts